import {executeQuery} from "@/data/repos/query"
import {extractAppraisalItem} from "@/data/repos/appraisal"

export async function getLocationCaption(locationId: any): Promise<string> {
  if (isNaN(parseInt(locationId.value))) { return "" }
  const locationResponse = await executeQuery("idr", "autocomplete_locationById", {id: locationId.value})
  return locationResponse ? locationResponse[0].name + " (" + locationResponse[0].code + ")" : "#" + locationId.value
}

export async function getLocationCaptionById(locationId: number): Promise<string> {
  console.debug("getLocationCaptionById:", locationId)
  const locationResponse = await executeQuery("idr", "autocomplete_locationById", {id: locationId})
  return locationResponse ? locationResponse[0].name + " (" + locationResponse[0].code + ")" : "???"
}

export function getAppraisalCaption(appraisalEntity: any): string | undefined {
  const item = extractAppraisalItem(appraisalEntity)
  return item && item.subelementId ? item.subelementTitle :
    item && item.elementId ? item.elementTitle :
      item && item.categoryId ? item.categoryTitle :
        item && item.facetId ? item.facetTitle :
          item && item.surveyId ? item.surveyTitle :
            "Survey not configured"
}
